/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ voice: NonNullable<unknown>, preferredVoice: NonNullable<unknown> }} Mobile_Voice_Downloaded_InInputs */

const en_mobile_voice_downloaded_in = /** @type {(inputs: Mobile_Voice_Downloaded_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Downloaded in ${i?.voice}. Remove the download to listen in ${i?.preferredVoice}.`)
};

const es_mobile_voice_downloaded_in = /** @type {(inputs: Mobile_Voice_Downloaded_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descargado con ${i?.voice}. Elimina la descarga para escuchar con ${i?.preferredVoice}.`)
};

/**
* | output |
* | --- |
* | "Downloaded in {voice}. Remove the download to listen in {preferredVoice}." |
*
* @param {Mobile_Voice_Downloaded_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_voice_downloaded_in = /** @type {((inputs: Mobile_Voice_Downloaded_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Voice_Downloaded_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_voice_downloaded_in(inputs)
	return en_mobile_voice_downloaded_in(inputs)
});